export enum Currency {
  ZAR,
}
